import {useLang} from "../context/LanguageContext";

const Footer = () => {
    const { t } = useLang();

    return (
        <div className="w-full max-w-[800px] m-auto my-2 bg-[#34495e] border-2 border-[#2ecc71] rounded-[10px] flex items-center justify-between p-2">
            <img src="/assets/images/18+.png" alt="18+" style={{width: "40px", height: "40px", marginRight:"16px"}} />
            <p className="text-sm font-extrabold text-[#e67e22]">{t('txt.18+')}</p>
        </div>
    )
}

export default Footer;